module.exports = __webpack_public_path__ + "static/img/icon-en-6.577bd6b1.png";